import app from 'flarum/forum/app';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import type Price from '../../common/Price';
import type Product from '../../common/Product';
import type Mithril from 'mithril';
import type Group from 'flarum/common/models/Group';
import LogInModal from 'flarum/forum/components/LogInModal';

export interface IPriceOptionAttrs extends ComponentAttrs {
  price: Price;
  product: Product;
  for: Group;
}

export default class PriceOption<CustomAttrs extends IPriceOptionAttrs = IPriceOptionAttrs> extends Component<CustomAttrs> {
  private price!: Price;
  private product!: Product;
  private for!: Group;
  private loading = false;
  private actor = app?.session?.user;

  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.price = this.attrs.price;
    this.product = this.attrs.product;
    this.for = this.attrs.for;
  }

  view() {
    return (
      <div className="PriceOption" style={this.for?.color() ? { backgroundColor: this.for.color() } : ''}>
        <h2 className="group">{this.price.cost}</h2>
        <div className="description">{this.recurring()}</div>
        <div className="controls">{this.button()}</div>
      </div>
    );
  }

  recurring() {
    if (this.price.type === 'one_time') {
      return 'once';
    } else if (this.price.type === 'recurring') {
      let str = ['every'];

      let interval = this.price.recurring.interval;

      if (this.price.recurring.interval_count > 1) {
        str.push(String(this.price.recurring.interval_count));
        interval += 's';
      }

      str.push(interval);

      return str.join(' ');
    }

    // @TODO: dead code?
    // @ts-ignore
    console.error('Unknown error for interval', this.error);

    return 'no interval known';
  }

  button() {
      if (!this.actor) {
          return <Button className="Button" onclick={() => app.modal.show(LogInModal)}>
              {app.translator.trans('core.forum.header.log_in_link')}
          </Button>
      }

    return Button.component(
      {
        icon: 'fas fa-shopping-cart',
        className: 'Button',
        onclick: this.request.bind(this),
        disabled: this.loading,
      },
      app.translator.trans('floxum-payments.forum.access-portal.purchase')
    );
  }

  request() {
    const handler = new Handler('pta', {
      price: this.price.id,
      product: this.product.id,
    });

    this.loading = true;
    handler.checkout();
  }

  // @TODO: dead code?
  redirect(response: any) {
    const sessionId = response.session_id;

    // @ts-ignore
    let stripe = Stripe(app.forum.pk());

    this.loading = false;

    stripe.redirectToCheckout({ sessionId });
  }
}
